export default "__VITE_ASSET__BXOj5L5M__"